import { formatNumbers } from "../../../../utils/NumberFormat";
import CustomBoxHeader from "../../../CommonComponents/CustomBoxHeader";
import styles from "./CompanyDetails2.module.css";
import { Row, Col } from "antd";
import { useState } from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { CgWebsite } from "react-icons/cg";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoLogoGithub } from "react-icons/io";
import TeamMemberTable from "./TeamMemberTable";
import InfoEditModal from "./InfoEditModal";
import HQEditModal from "./HQEditModal";
import BioEditModal from "./BioEditModal";
import BenefitsModal from "./BenefitsModal";
import SocialModal from "./SocialModal";

const CompanyDetails2 = ({ data = {}, loading, refatchData }) => {
  const [showModal, setShowModal] = useState("");

  const companyInformaton = [
    {
      label: "Name",
      value: data?.Identification?.companyName,
    },
    {
      label: "Phone",
      value: data?.Identification?.phoneNumber,
    },
    {
      label: "Email Address",
      value: data?.Identification?.email,
    },
    {
      label: "Website",
      value: data?.companyUrl,
    },
    {
      label: "Sector",
      value: data?.sector,
    },
    {
      label: "Industry",
      value: data?.industry,
    },
    {
      label: "Glassdoor Url",
      value: data?.companyGlassdoorUrl,
    },
    {
      label: "Size (people)",
      value: formatNumbers(data?.noOfEmployees),
    },
    {
      label: "Size (turnover)",
      value: "$" + formatNumbers(data?.yearlyRevenue),
    },
  ];

  const companyHQInfo = [
    {
      label: "Country",
      value: data?.companyAddress?.country,
    },
    {
      label: "State/City",
      value: data?.companyAddress?.state,
    },
    {
      label: "Address",
      value: data?.companyAddress?.corpContact,
    },
    {
      label: "Postcode/Zip",
      value: data?.companyAddress?.zip,
    },
    {
      label: "Federal Tax ID",
      value: data?.companyAddress?.fedaralTaxId,
    },
  ];

  const companyDetails = [
    {
      label: "Values:",
      value: data?.companyValues || [],
    },
    {
      label: "Benefits:",
      value: data?.companyBenefits || [],
    },
  ];

  const icons = {
    linkedin: <FaLinkedin />,
    fb: <FaFacebook />,
    insta: <FaInstagram />,
    Website: <CgWebsite />,
    twitter: <FaSquareXTwitter />,
    github: <IoLogoGithub />,
  };

  const handleEdit = (type) => {
    setShowModal(type);
  };

  const handleClick = (url) => {
    window.open(url, "_blank");
  };

  const handleSubmit = () => {
    refatchData();
  };

  return (
    <>
      <Row gutter={[8, 8]} className={styles.column_wrap}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap}>
            <CustomBoxHeader
              title={"Company Information"}
              action={() => handleEdit("INFO_MODAL")}
            />
            <Row gutter={[18, 24]} className={styles.data_wrap}>
              {companyInformaton.map((item) => {
                return (
                  <Col xs={24} sm={12} md={12} lg={8} xl={8}>
                    <div>
                      <div className={styles.label}>{item.label}</div>
                      <div className={styles.info}>{item.value}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap}>
            <CustomBoxHeader
              title={"Company HQ Address"}
              action={() => handleEdit("HQ_MODAL")}
            />
            <Row gutter={[12, 24]} className={styles.data_wrap}>
              {companyHQInfo.map((item) => {
                return (
                  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <div className={styles.label}>{item.label}</div>
                      <div className={styles.info}>{item.value}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_3}>
            <CustomBoxHeader
              title={"Company Biography"}
              action={() => handleEdit("BIO_MODAL")}
            />
            <div className={styles.biography}>{data?.companyDescription}</div>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_2}>
            <CustomBoxHeader
              title={"Company Social Channels"}
              action={() => handleEdit("SOCIAL_MODAL")}
            />
            <Row gutter={[8, 8]} className={styles.data_wrap}>
              {data.companyChannels &&
                Object.keys(data.companyChannels)?.map((item) => {
                  return (
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                      <div
                        className={styles.icon_wrap}
                        onClick={() => handleClick(data.companyChannels[item])}
                      >
                        {icons[item]}
                        {item}
                      </div>
                    </Col>
                  );
                })}
              {data.companyUrl && (
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <div
                    className={styles.icon_wrap}
                    onClick={() => handleClick(data.companyUrl)}
                  >
                    {icons["Website"]}
                    Website
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_4}>
            <CustomBoxHeader
              title={"Company Values & Benefits"}
              action={() => handleEdit("BENEFITS_MODAL")}
            />
            <Row gutter={[12, 24]} className={styles.data_wrap}>
              {companyDetails.map((item) => {
                return (
                  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <div className={styles.label_2}>{item.label}</div>
                      {item.value.map((text) => {
                        return <p className={styles.info}>— {text}</p>;
                      })}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>
      </Row>
      <div className={styles.table_wrap}>
        <TeamMemberTable
          height={350}
          data={data?.membersData || []}
          loading={loading}
        />
        <InfoEditModal
          data={data}
          isOpen={showModal === "INFO_MODAL"}
          onSubmit={handleSubmit}
          onCancel={setShowModal}
        />
        <HQEditModal
          data={data}
          isOpen={showModal === "HQ_MODAL"}
          onSubmit={handleSubmit}
          onCancel={setShowModal}
        />
        <BioEditModal
          data={data}
          isOpen={showModal === "BIO_MODAL"}
          onSubmit={handleSubmit}
          onCancel={setShowModal}
        />
        <SocialModal
          data={data}
          isOpen={showModal === "SOCIAL_MODAL"}
          onSubmit={handleSubmit}
          onCancel={setShowModal}
        />
        <BenefitsModal
          data={data}
          isOpen={showModal === "BENEFITS_MODAL"}
          onSubmit={handleSubmit}
          onCancel={setShowModal}
        />
      </div>
    </>
  );
};

export default CompanyDetails2;
